import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import './cp-spinner.css';

const HooperLoadingWithText = ({ loadingMsg, isShowSpinner }) => {
  if (!isShowSpinner) return null;

  return ReactDOM.createPortal(
    <div className="hooper_loading_overlay">
      <div className="hooper_loading_dv_old">
        <div className="hooper_loading_spinner_icon" />
        <div className="text_div_content">{loadingMsg}</div>
      </div>
    </div>,
    document.body, // Mount spinner in the body
  );
};

HooperLoadingWithText.propTypes = {};
HooperLoadingWithText.propTypes = {
  loadingMsg: PropTypes.any,
  isShowSpinner: PropTypes.bool,
};
export default HooperLoadingWithText;
